import { IDeclarationPost, IDeclarationPostPersistence } from '../interfaces';

export class DeclarationPostMapper {
  public static toDomain(p: IDeclarationPostPersistence): IDeclarationPost {
    return {
      id: p.id,
      read: !!p.is_new,
      price: p.price ? parseFloat(p.price) : null,
      dgkPrice: p.dgk_price ? parseFloat(p.dgk_price) : null,
      user: { id: p.user_id, name: p.user_name },
      trackCode: p.track_code,
      declarationId: p.declaration_id,
      customsId: p.customs_id,
      createdAt: p.created_at,
    };
  }
}
